/**
 * Headers for calls to our own `/api/*` endpoints. The session travels in the
 * httpOnly cookie, so there is no token here: only the `X-Portal` marker the
 * server demands on every request that is not a GET.
 * Kept async so the existing `...(await authHeaders())` call sites stay as they are.
 */
export async function authHeaders(): Promise<Record<string, string>> {
  return { 'X-Portal': '1' };
}
